
import { LanguageTexts } from '../types'
export const Text: LanguageTexts = {
  es: {
    'Error500Details': 'Lo sentimos, ha ocurrido un problema. Por favor, intenta nuevamente más tarde.',
    'LogOut': 'Cerrar sesión',
    'MyProfile': 'Mi perfil',
    'ChangePassword': 'Cambiar contraseña',
    'Profile': 'Perfil',
    'Location': 'Sede',
    'menuPpal': 'Principal',
    'menuDate': 'Agenda',
    'menuConections': 'Sist. externos',
    'menuPatient': 'Pacientes',
    'menuSamples': 'Muestras',
    'menuOrders': 'Órdenes',
    'menuPreOrders': 'Preórdenes',    
    'menuSearches': 'Búsquedas',
    'menuSearchesOrders': 'Buscar Resultados',
    'menuSearchesPatients': 'Buscar Pacientes',
    'menuBilling': 'Facturación',
    'menuQuotations':'Cotizaciones',
    'menuCashier':'Caja',
    'menuReports': 'Reportes',
    'menuTraceability': 'Trazabilidad',
    'menuExternalRemisions': 'Remisiones Externas',
    'menuWarnings': 'Alarmas',
    'menuConfiguration': 'Preferencias',
    'menuConfigurationAgenda': 'Agenda',
    'menuConfigurationAnalitos': 'Analitos',
    'menuConfigurationAlarmas': 'Alarmas',
    'menuConfigurationConfigGeneral': 'Configuración general',
    'menuConfigurationAnalitosPlantillas': 'Analitos Plantillas',
    'menuConfigurationAnalitosTiposMuestras': 'Tipos muestras',
    'menuConfigurationAnalizadores': 'Analizadores',
    'menuConfigurationBarcode': 'Barcodes',
    'menuConfigurationQC': 'Configuración QC',
    'menuQC': 'Control de Calidad',
    'menuMeasurementsQC': 'Mediciones QC',
    'menuMasiveMeasurementsQC': 'Mediciones QC',
    'menuConfigurationCamposDinamicos': 'Campos dinámicos',
    'menuConfigurationEstudios': 'Estudios',
    'menuConfigurationFacturacion': 'Facturación',
    'menuConfigurationImpresoraCodBarras': 'Impresora C. Barras',
    'menuConfigurationEstudiosPerfiles': 'Perfiles Estudios',
    'menuConfigurationPermisos': 'Permisos',
    'menuConfigurationReportes': 'Reportes',
    'menuConfigurationReportesInformes': 'Reportes Informes',
    'menuConfigurationReportesInformesDisenador': 'Diseñador reportes',
    'menuConfigurationTablas': 'Mantenimientos',
    'menuConfigurationDefiniciones': 'Definiciones',
    'menuConfigurationUsuarios': 'Usuarios',
    'menuConfigWebPagePatients': 'Página Web Resultados',
    'menuConfigurationTareasOperativa': 'Tareas operativas',
    'menuConfigurationNotes': 'Plantillas Notas',
    'menuConfigurationEmailTemplates': 'Plantillas Email',
    'menuConfigInformedConsents': 'Consentimientos Informados',
    'menuConfigBackups': 'Backups',
    'menuConfigurationTareasOperativaCerrarOrdenes': 'Tareas operativas - Cerrar órdenes',
    'menuConfigurationTareasOperativaDisenos': 'Tareas operativas - Diseños',
    'menuTracking': 'Tracking',
    'menuSerumLibrary': 'Seroteca',
    'menuAdminOrders': 'Órdenes',
    'menuBarcodes': 'Cod Barras',
    'menuReferrals': 'Remisiones',    
    'menuAdminResultados': 'Admin Resultados',
    'menuFindResults': 'Buscar resultados',
    'menuMassPrinting': 'Impresión masiva',
    'menuMassValidation': 'Validación masiva',
    'menuTimers': 'Temporizadores',
    'menuDashboards': 'Tableros BI',
    'menuWorkList': 'Listas de trabajo',
    'menuReportsandstatistics': 'Reportes/ estadisticas',
    'menuControlBoards': 'Tableros de control',
    'menuAnalizers': 'Analizadores',
    'toolBarNew': 'Nuevo',
    'toolBarEdit': 'Editar',
    'toolBarDelete':'Eliminar',
    'toolBarSave': 'Guardar',
    'toolBarCancel': 'Cancelar',
    'requiredField': 'es requerido',
    'invalidFormat': 'Formato no válido',
    'saveButton': 'Guardar',
    'SavingButton': 'Procesando',
    'modeNewItem': 'Creando una orden',
    'modeUpdateItem': 'Editando una orden',
    'modeLoading': 'Cargando',
    'modeViewItem': 'Visualizando una orden',
    'modeUndefined': 'Indefinido',
    'modeActual': 'Actualmente estás',
    'filterButton': 'Filtrar',
    'socketErrorConnect':'Error conectándose al notificador de eventos.',
    'search':'Buscar orden',
    'conexStatusOk':'Conexión exitosa al servidor',
    'conexStatusError':'Se ha perdido la conexión con el servidor',
    'confirmationMessage':'Confirmación'
  },
  en: {
    'Error500Details': 'We\'re sorry, an issue occurred. Please try again later.',
    'LogOut': 'Log out',
    'MyProfile': 'My Profile',
    'ChangePassword': 'Change Password',
    'Profile': 'Profile',
    'Location': 'Work location',
    'menuConections': 'Conexiones',
    'menuPpal': 'Dashboard',
    'menuDate': 'Appointments',
    'menuPatient': 'Patients',
    'menuSamples': 'Samples',
    'menuOrders': 'Orders',
    'menuPreOrders': 'Preorders',    
    'menuSearches': 'Searches',
    'menuSearchesOrders': 'Orders',
    'menuSearchesPatients': 'Patients',
    'menuBilling': 'Billing',
    'menuQuotations':'Quotations',
    'menuCashier':'Cashier',
    'menuReports': 'Reports',
    'menuTraceability': 'Traceability',
    'menuExternalRemisions': 'External Remissions',
    'menuWarnings': 'Warnings',
    'menuConfiguration': 'Preferences',
    'menuConfigurationAgenda': 'Schedule',
    'menuConfigurationAnalitos': 'Analytes',
    'menuConfigurationAlarmas': 'Alarms',
    'menuQC': 'Quality Control',
    'menuConfigurationQC': 'QC Settings',
    'menuMeasurementsQC': 'QC Measurements',
    'menuMasiveMeasurementsQC': 'QC Mass Entry',
    'menuConfigurationAnalitosPlantillas': 'Analitos Plantillas',
    'menuConfigurationAnalitosTiposMuestras': 'Tipos muestras',
    'menuConfigurationAnalizadores': 'Analizadores',
    'menuConfigurationBarcode': 'Barcodes',
    'menuConfigurationCamposDinamicos': 'Campos dinámicos',
    'menuConfigurationEstudios': 'Estudios',    
    'menuConfigurationFacturacion': 'Billing',
    'menuConfigurationEstudiosPerfiles': 'Perfiles Estudios',
    'menuConfigurationImpresoraCodBarras': 'Barcode printer',
    'menuConfigurationPermisos': 'Permisos',
    'menuConfigurationReportes': 'Reportes',
    'menuConfigurationReportesInformes': 'Reportes Informes',
    'menuConfigurationReportesInformesDisenador': 'Diseñador reportes',
    'menuConfigurationTablas': 'Mantenimientos',
    'menuConfigurationDefiniciones': 'Definiciones',
    'menuConfigurationUsuarios': 'Usuarios',
    'menuConfigWebPagePatients': 'Web Page Results',
    'menuConfigurationTareasOperativa': 'Tareas operativas',
    'menuConfigurationNotes': 'Notes',
    'menuConfigurationEmailTemplates': 'Email Templates',
    'menuConfigInformedConsents': 'Informed Consents',
    'menuConfigBackups': 'Backups',
    'menuConfigurationTareasOperativaCerrarOrdenes': 'Tareas operativas - Cerrar órdenes',
    'menuConfigurationTareasOperativaDisenos': 'Tareas operativas - Diseños',
    'menuTracking': 'Tracking',
    'menuSerumLibrary': 'Serum Library',
    'menuAdminOrders': 'Orders',
    'menuBarcodes': 'Barcodes',
    'menuReferrals': 'Referrals',
    'menuAdminResultados': 'Admin Results',
    'menuFindResults': 'Find Results',
    'menuMassPrinting': 'Mass Printing',
    'menuMassValidation': 'Mass Validation',
    'menuTimers': 'Timers',
    'menuDashboards': 'Dashboards',
    'menuWorkList': 'Work List',
    'menuReportsandstatistics': 'Reports/ statistics',
    'menuControlBoards': 'Control Boards',
    'menuAnalizers': 'Analizers',
    'toolBarNew': 'New',
    'toolBarEdit': 'Edit',
    'toolBarDelete':'Delete',
    'toolBarSave': 'Save',
    'toolBarCancel': 'Cancel',
    'requiredField': 'is required',
    'invalidFormat': 'Invalid format',
    'saveButton': 'Save',
    'SavingButton': 'Saving',
    'modeNewItem': 'New',
    'modeUpdateItem': 'Edit',
    'modeLoading': 'Loading',
    'modeViewItem': 'View',
    'modeUndefined': 'Undefined',
    'modeActual': 'Actual mode',
    'filterButton': 'Filter',
    'socketErrorConnect':'Error connecting to the event notifier',
    'search':'Search order',
    'conexStatusOk':'Successful connection to the server',
    'conexStatusError':'The connection to the server has been lost',
    'confirmationMessage':'Confirmation'
  }
};